<template>
  <vl-layer-vector
    :visible="activeGridOverlay"
    :extent="imageExtent"
    :update-while-animating="true"
    :update-while-interacting="true"
  >

    <vl-source-vector :features="grid" />
    <vl-style-box>
      <vl-style-stroke :color="color"/>
    </vl-style-box>

  </vl-layer-vector>
</template>

<script>
import {LineString} from 'ol/geom';
import {Feature} from 'ol';
import {blue, gray} from '@/utils/style-utils';

const GRID_SIZE = 544;
const GRID_OFFSET_X = 32;
const GRID_OFFSET_Y = 24;

export default {
  name: 'histolog-grid-overlay',
  props: {
    index: String,
  },
  data() {
    return {
      grid: []
    };
  },
  computed: {
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    image() {
      return this.imageWrapper.imageInstance;
    },
    imageExtent() {
      return [0, 0, this.image.width, this.image.height];
    },
    activeGridOverlay() {
      return this.imageWrapper.view.activeGridOverlay;
    },
    violetColormap() {
      return this.imageWrapper.colorOverlay.violetColormap;
    },
    color() {
      return (this.violetColormap) ? gray : blue;
    }
  },
  methods: {
    buildGrid() {
      this.grid.splice(0, this.grid.length);

      // Vertical lines
      for (let x = GRID_OFFSET_X + 0.5; x <= this.image.width - GRID_OFFSET_X + 0.5; x += GRID_SIZE) {
        this.grid.push(new Feature(new LineString([[x, 0], [x, this.image.height]])));
      }

      // Horizontal lines
      for (let y = GRID_OFFSET_Y - 0.5; y <= this.image.height - GRID_OFFSET_Y; y += GRID_SIZE) {
        this.grid.push(new Feature(new LineString([[0, y], [this.image.width, y]])));
      }
    },
  },
  created() {
    this.buildGrid();
  }
};
</script>
